import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.award-slider' ).length ) {
        $( '.award-slider' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '32px',
            pagination: false,
            speed: 800,
            breakpoints: {
              768: {
                perPage: 1,
              },
            },
          } );

          splide.on( 'mounted resize', () => {
            const perPage = splide.options.perPage;
            const slideCount = splide.length;

            splide.options = {
              arrows: slideCount > perPage,
              drag: slideCount > perPage,
            };
          } );

          splide.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'award-slider', COMPONENT );
} )( app );
